<template>
	<div class="Login">
		<div class="window d-flex j-sb a-center">
			<div class="left h-100 d-flex flex-column j-center a-center">
				<img src="@/assets/Login/shanghuguanyu@2x.png" style="width: 8.41rem;height: 8.41rem;">
				<span class="text">企业微网站后台管理系统</span>
			</div>
			<div class="right h-100 d-flex flex-column j-sb a-start position-relative">
				<a href="http://microweb.cn/sxhAdmin/#/Login"
				style="height: 60px;right: 23px;top: 0;color: #1E69FF;font-size: 24px;font-weight: 700;text-decoration:none" 
				class="d-flex a-center position-absolute">
					<img style="width: 30px;height: 30rpx;" src="../../assets/Login/qiehuan.png" /> 商协会登录
				</a>
				<span style="font-size: 1.88rem;font-weight: bold;">登录</span>
				<label for="username" class="d-flex flex-column j-sb a-start" style="font-size: 1.5rem;color: #BBBBBB;">
					<span>账号</span>
					<div class="wrap w-100" style="margin-top: 1.88rem;">
						<input class="input" autocomplete="off" v-model="username" id="username" type="text" placeholder="请输入您已注册的账号">
					</div>
				</label>
				<label for="password" class="d-flex flex-column j-sb a-start" style="font-size: 1.5rem;color: #BBBBBB;">
					<span>登录密码</span>
					<input class="input" style="margin-top: 1.44rem;" autocomplete="new-password" v-model="password" id="password"
					 type="password" placeholder="请输入您的密码">
				</label>
				<router-link to="/Forget" custom v-slot="{ navigate }" class="forgotten">
					<span @click="navigate" @keypress.enter="navigate" role="link">忘记密码?</span>
				</router-link>
				<el-button class="button" @click="login" :disabled="!username||!password" :style="username&&password?'opacity: 1':'opacity:.5;'">登录</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		debounce,
		throttle
	} from '@/utils/index.js'
	export default {
		data() {
			return {
				user_info: '',
				username: '',
				password: '',
				last_ip: '',
				cid: ''
			}
		},
		mounted() {
			this.getIP()
			window.onkeydown = (e) => {
				if (e.keyCode == 13) {
					this.login()
				}
			}
		},
		methods: {
			getIP() {
				const service2 = this.$axios.create({
					baseURL: '/cityjson'
				})
				service2.get('/cityjson').then((res) => {
					let ipInfo = JSON.parse(res.data.match(/{[^}]*}/g)[0])
					this.last_ip = ipInfo.cip
					this.cid = ipInfo.cid
				})
			},
			login: throttle(function() {
				let param = {
					act: 'login',
					username: this.username,
					password: this.password
				}
				this.$api.login(param).then((res) => {
					if (res.code == 0) {
						localStorage.setItem('user_id', res.data.user_id)
						localStorage.setItem('token', res.data.token)
						localStorage.setItem('ru_id', res.data.ru_id)
						localStorage.setItem('store_type', res.data.store_type)
						localStorage.setItem('multiport', JSON.stringify(res.data.multiport))
						let par = {
							act:'get_company_info',
							token: localStorage.getItem('token'),
							user_id: localStorage.getItem('user_id'),
						}
						this.$api.get_company_info(par).then((res)=>{
							localStorage.setItem('user_info', JSON.stringify(res.data))
							this.$router.replace('Home')
							this.$message({
								showClose: true,
								message: '登录成功',
								type: 'success',
								offset: 350
							})
						})
					} else {
						this.$message({
							showClose: true,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			}, 1000)
		}
	}
</script>

<style scoped lang="less">
	.Login {
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		background: url(../../assets/Login/beijing@2x.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;

		.window {
			width: 70.75rem;
			height: 40.45rem;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			border-radius: 25px;
			box-shadow: 0 22px 85px 0 rgba(13, 56, 141, 0.3);

			.left {
				width: 50%;
				background: url(../../assets/Login/bg2.png);
				background-size: 100% 100%;
				background-repeat: no-repeat;
				border-radius: 25px 0 0 25px;

				.text {
					font-size: 2.5rem;
					font-weight: bold;
					color: #1E69FF;
					line-height: 2.5rem;
				}
			}

			.right {
				width: 50%;
				background: #FFFFFF;
				padding: 5.4rem 6.8rem;
				box-sizing: border-box;
				border-radius: 0 25px 25px 0;

				label {
					width: 100%;
					font-weight: bold;

					.input {
						outline: none;
						border: 2px solid rgba(30, 105, 255, .7);
						font-size: 1.25rem;
						height: 3.74rem;
						width: 100%;
						border-radius: 8px;
						color: #000000;
						font-weight: bold;
						padding: 0 1.3rem;
						box-sizing: border-box;

						&:focus {
							border-color: rgba(30, 105, 255, 1);
						}

						&::-webkit-input-placeholder {
							color: #BBBBBB;
						}

						&::-moz-placeholder {
							/* Mozilla Firefox 19+ */
							color: #BBBBBB;
						}

						&:-moz-placeholder {
							/* Mozilla Firefox 4 to 18 */
							color: #BBBBBB;
						}

						&:-ms-input-placeholder {
							/* Internet Explorer 10-11 */
							color: #BBBBBB;
						}
					}
				}

				.forgotten {
					align-self: flex-end;
					color: #1E69FF;
					font-weight: bold;
					text-decoration: none;
					cursor: pointer;

					&:hover {
						text-decoration: underline;
					}
				}

				.button {
					width: 100%;
					height: 3.74rem;
					border-radius: 30px;
					color: #FFFFFF;
					background: #1E69FF;
					border: none;
					font-size: 1.5rem;
					font-weight: bold;
					outline: none;
				}
			}
		}
	}
</style>
